import axios from 'axios';

const isProduction = process.env.NODE_ENV === 'production';
const baseUrl = isProduction
  ? 'http://ryysterbrewery.com:3000'
  : 'http://localhost:3000';

// eslint-disable-next-line consistent-return
const loadState = async () => {
  try {
    const response = await axios.get(baseUrl + '/state');

    if (response.status === 200) {
      return response.data;
    }
    return null;
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
  }
};

const resetState = async () => {
  try {
    const response = await axios.delete(baseUrl + '/state');
    return response;
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log(err);
    return false;
  }
};

export default {
  loadState,
  resetState,
};
